import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CreateRealizationModal({ Realization, onClose, refreshData }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [startAt, setStartAt] = useState('');
  
  // { url: string, file: File | null, isExisting: boolean, fileName: string }
  const [allImages, setAllImages] = useState([]);
  const [step, setStep] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0); // Dla podglądu w kroku 2
  const [error, setError] = useState('');

  useEffect(() => {
    if (Realization) {
      setTitle(Realization.name || '');
      setDescription(Realization.description || '');
      setLocation(Realization.location || '');
      if (Realization.start_at) {
        setStartAt(new Date(Realization.start_at).toISOString().split('T')[0]);
      }

      const baseUrl = `https://megamont.pl/uploads/realizacja_${Realization.id}/`;
      const imagesFromDb = JSON.parse(Realization.images || "[]");
      
      const existing = imagesFromDb.map(img => ({
        url: baseUrl + img,
        file: null,
        isExisting: true,
        fileName: img
      }));
      setAllImages(existing);
    }
  }, [Realization]);

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const newItems = files.map(file => ({
      url: URL.createObjectURL(file),
      file: file,
      isExisting: false,
      fileName: file.name
    }));

    setAllImages(prev => [...prev, ...newItems]);
    e.target.value = null;
  };

  const removeImage = (indexToRemove) => {
    const item = allImages[indexToRemove];
    if (!item.isExisting) {
      URL.revokeObjectURL(item.url);
    }
    setAllImages(prev => prev.filter((_, index) => index !== indexToRemove));
  };

  const moveImage = (index, direction) => {
    const newImages = [...allImages];
    const targetIndex = direction === 'left' ? index - 1 : index + 1;
    if (targetIndex < 0 || targetIndex >= newImages.length) return;
    [newImages[index], newImages[targetIndex]] = [newImages[targetIndex], newImages[index]];
    setAllImages(newImages);
  };

  const handleFinalSubmit = async () => {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('location', location);
    formData.append('start_at', startAt);
    
    // Lista istniejących plików w nowej kolejności
    const imagesToKeep = allImages
      .filter(item => item.isExisting)
      .map(item => item.fileName);
    
    formData.append('existingImages', JSON.stringify(imagesToKeep));

    // Dodajemy nowe pliki
    allImages.forEach(item => {
      if (!item.isExisting) {
        formData.append('images', item.file);
      }
    });

    try {
      const config = { headers: { 'Content-Type': 'multipart/form-data' } };
      if (Realization) {
        await axios.put(`https://megamont.pl/api/realizations/${Realization.id}`, formData, config);
      } else {
        await axios.post('https://megamont.pl/api/realizations', formData, config);
      }
      refreshData();
      onClose();
    } catch (err) {
      setError("Wystąpił błąd podczas zapisywania danych.");
    }
  };

  const navBtnStyle = (dir) => ({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    [dir]: '15px',
    background: 'rgba(255,255,255,0.9)',
    border: 'none',
    borderRadius: '50%',
    width: '45px',
    height: '45px',
    cursor: 'pointer',
    fontSize: '24px',
    zIndex: 10,
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });

  return (
    <div className="modal-overlay">
      {step === 1 && (
        <div className="modal-content" style={{ maxWidth: '900px' }}>
          <button type="button" className="modal-close-button" onClick={onClose}>&times;</button>
          <h2 className="mb-4">{Realization ? '✏️ Edytuj Realizację' : '➕ Dodaj Nową Realizację'}</h2>
          
          <form onSubmit={(e) => { 
            e.preventDefault(); 
            allImages.length > 0 ? setStep(2) : setError('Dodaj min. 1 zdjęcie'); 
          }}>
            {error && <div className="alert alert-danger">{error}</div>}
            
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label className="fw-bold">Tytuł</label>
                        <input type="text" className="form-control" value={title} onChange={(e) => setTitle(e.target.value)} required />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-group mb-3">
                        <label className="fw-bold">Lokalizacja</label>
                        <input type="text" className="form-control" value={location} onChange={(e) => setLocation(e.target.value)} required />
                    </div>
                </div>
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">Opis</label>
              <textarea className="form-control" style={{minHeight:"250px"}} value={description} onChange={(e) => setDescription(e.target.value)} rows="3" required />
            </div>

            <div className="form-group mb-3">
              <label className="fw-bold">Data realizacji</label>
              <input type="date" className="form-control" value={startAt} onChange={(e) => setStartAt(e.target.value)} required />
            </div>

            <div className="form-group mt-4">
              <label className="btn btn-primary w-100 p-3 shadow-sm" style={{color:"white"}}>
                <i className="fas fa-camera me-2"></i> Wybierz zdjęcia do galerii
                <input type="file" hidden accept="image/*" multiple onChange={handleImageChange} />
              </label>
            </div>

            <div className="image-preview-grid mt-4 p-3 border rounded bg-light" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: '15px' ,height:"fit-content"}}>
              {allImages.map((item, index) => (
                <div key={index} className="preview-card bg-white rounded shadow-sm overflow-hidden border" style={{ position: 'relative' }}>
                  <div className="image-wrapper" style={{ height: '140px', position: 'relative' }}>
                    <img src={item.url} alt="podgląd" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                    {index === 0 && (
                        <span className="badge bg-warning text-dark" style={{ position: 'absolute', top: '5px', left: '5px', fontSize: '10px' }}>Główne</span>
                    )}
                  </div>
                  
                  <div className="d-flex justify-content-between p-1 bg-dark">
                    <button type="button" className="btn btn-sm btn-outline-light border-0" onClick={() => moveImage(index, 'left')} disabled={index === 0}>
                      <i className="fas fa-arrow-left"></i>
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-danger border-0" onClick={() => removeImage(index)}>
                      <i className="fas fa-trash-alt"></i>
                    </button>
                    <button type="button" className="btn btn-sm btn-outline-light border-0" onClick={() => moveImage(index, 'right')} disabled={index === allImages.length - 1}>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-actions mt-4 border-top pt-3 d-flex justify-content-end gap-2">
              <button type="button" className="btn btn-light px-4" onClick={onClose}>Anuluj</button>
              <button type="submit" className="btn btn-primary px-5">Dalej <i className="fas fa-chevron-right ms-2"></i></button>
            </div>
          </form>
        </div>
      )}

      {step === 2 && (
        <div className="modal-content" style={{ maxWidth: '800px' }}>
          <button type="button" className="modal-close-button" onClick={onClose}>&times;</button>
          <h2 className="mb-4 text-center">Finalny podgląd galerii</h2>
          
          <div className="custom-carousel" style={{ position: 'relative', background: '#222', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ height: '450px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img 
                src={allImages[activeIndex]?.url} 
                style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
                alt="preview"
              />
            </div>

            {allImages.length > 1 && (
              <>
                <button type="button" style={navBtnStyle('left')} onClick={() => setActiveIndex(prev => (prev === 0 ? allImages.length - 1 : prev - 1))}>❮</button>
                <button type="button" style={navBtnStyle('right')} onClick={() => setActiveIndex(prev => (prev === allImages.length - 1 ? 0 : prev + 1))}>❯</button>
              </>
            )}

            <div style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', padding: '5px 15px', borderRadius: '20px' }}>
              {activeIndex + 1} / {allImages.length}
            </div>
          </div>

          <div className="d-flex justify-content-center mt-3 gap-2 overflow-auto py-2">
            {allImages.map((img, idx) => (
              <img 
                key={idx} 
                src={img.url} 
                onClick={() => setActiveIndex(idx)}
                style={{ 
                  width: '60px', 
                  height: '40px', 
                  objectFit: 'cover', 
                  cursor: 'pointer',
                  border: activeIndex === idx ? '2px solid #007bff' : '2px solid transparent',
                  borderRadius: '4px',
                  opacity: activeIndex === idx ? 1 : 0.5
                }} 
              />
            ))}
          </div>
          
          <div className="modal-actions mt-4 d-flex justify-content-between border-top pt-3">
            <button type="button" className="btn btn-outline-secondary px-4" onClick={() => { setStep(1); setActiveIndex(0); }}>
              <i className="fas fa-arrow-left me-2"></i> Wróć do edycji
            </button>
            <button type="button" className="btn btn-success px-5 shadow" onClick={handleFinalSubmit}>
              {Realization ? 'Zapisz zmiany' : 'Zapisz realizację'}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}